import styled from 'styled-components';

import { Tabs } from 'antd';

export const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin: 0;
    border-bottom: 2px solid #e5e7eb; /* light gray separator line */
    background: #fff; /* keep full row white */
  }

  .ant-tabs-tab {
    font-size: 18px; /* heading-like font size */
    font-weight: 600; /* bold */
    margin-right: 40px; /* spacing between tabs */
    color: #374151; /* default dark gray text */
    padding: 12px 0; /* more vertical padding */
  }

  .ant-tabs-tab:hover {
    color: #1890ff; /* hover blue */
  }

  .ant-tabs-tab-active {
    color: #1890ff !important; /* active tab text blue */
  }

  .ant-tabs-ink-bar {
    background: #1890ff !important; /* underline color */
    height: 4px; /* thicker underline */
    border-radius: 2px; /* rounded underline */
  }

  /* remove the default card-like style */
  .ant-tabs-nav-wrap {
    background: transparent;
  }
`;
